export default "__VITE_ASSET__S2yv_PmH__"